export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 1000,
    source: "https://bitfarms.com/app/uploads/2021/05/BITFARMS-Q1-2021-PR-Final-Clean.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 1293,
    source: "https://bitfarms.com/app/uploads/2021/08/BITFARMS-Q2-2021-PR-FINAL.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 2300,
    source: "https://bitfarms.com/app/uploads/2021/10/Bitfarms-Press-Release-Sep-BTC-Production-Update-FINAL-CLEAN-v5.c-Oct-1-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: "https://bitfarms.com/app/uploads/2020/06/BITFARMS-Q1-2020-News-Release-Final.pdf"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: "https://www.businesswire.com/news/home/20200828005036/en/"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 0,
    source: "https://www.businesswire.com/news/home/20201126005462/en/Bitfarms-Reports-Q3-2020-Financial-Results"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 0,
    source: "https://bitfarms.com/app/uploads/2021/03/BITFARMS-Q4-2020-NEWS-RELEASE-FINAL.pdf"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 548,
    source: "https://bitfarms.com/app/uploads/2021/05/BITFARMS-Q1-2021-PR-Final-Clean.pdf"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 1293,
    source: "https://bitfarms.com/app/uploads/2021/08/BITFARMS-Q2-2021-PR-FINAL.pdf"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 2300,
    source: "https://bitfarms.com/app/uploads/2021/10/Bitfarms-Press-Release-Sep-BTC-Production-Update-FINAL-CLEAN-v5.c-Oct-1-2021.pdf"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
